module.exports = __webpack_public_path__ + "static/blog.f10ee477.JPG";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/blog.JPG
// module id = 790
// module chunks = 0 6